/*
  Collection description "Read more / Read less" (sections/main-collection.liquid).
  The text is clamped by CSS (.coldesc-more-less:not(.expanded)); the button only
  appears when the clamped text actually overflows.
*/
class CollectionDescription extends HTMLElement {
  connectedCallback() {
    this.inner = this.querySelector('.coldesc-more-less-inner');
    this.button = this.querySelector('.readmore-less-btn');
    this.label = this.button?.querySelector('.readtxt');
    if (!this.inner || !this.button) return;

    this.button.addEventListener('click', this.toggle);
    this.observer = new ResizeObserver(() => this.update());
    this.observer.observe(this.inner);
    this.update();
    // Web fonts and images can change the text height after first paint
    document.fonts?.ready.then(() => this.update());
    window.addEventListener('load', () => this.update(), { once: true });
  }

  disconnectedCallback() {
    this.button?.removeEventListener('click', this.toggle);
    this.observer?.disconnect();
  }

  update() {
    if (this.classList.contains('expanded')) return;
    this.button.hidden = this.inner.scrollHeight <= this.inner.clientHeight + 1;
  }

  toggle = () => {
    const expanded = this.classList.toggle('expanded');
    this.button.setAttribute('aria-expanded', String(expanded));
    this.label.textContent = expanded ? this.dataset.readLess : this.dataset.readMore;
  };
}

if (!customElements.get('collection-description')) {
  customElements.define('collection-description', CollectionDescription);
}
